import React, { memo } from "react";

import styles from "./styles.module.scss";

const ProfileCheckListItem = ({ checked, text }: any) => {
	return (
		<div className={styles.profileCheckListItem}>
			{checked ? (
				<span
					className={`${styles.defaultSquare} ${styles.checkedSquare}`}
				></span>
			) : (
				<span className={styles.defaultSquare}></span>
			)}
			<p>{text}</p>
		</div>
	);
};

export default memo(ProfileCheckListItem);
